Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
  constructor: ({name, title}) ->
    @name = notNull(name)
    @title = notNull(title)

  getName: =>
    @name

  getTitle: =>
    @title
